"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const youtubeEmbedder = (md) => {
    const defaultRender = md.renderer.rules.image;
    md.renderer.rules.image = (tokens, idx, options, env, self) => {
        const token = tokens[idx], aIndex = token.attrIndex('src');
        if (token && token.attrs && token.attrs[aIndex] && (token.attrs[aIndex][1].includes('youtube.com') || token.attrs[aIndex][1].includes('youtube-nocookie.com'))) {
            const id = token.attrs[aIndex][1].split('/').slice(-1)[0];
            return `<iframe width="100%" height="500px" src="https://www.youtube-nocookie.com/embed/${id}" frameborder="0" allow="accelerometer;" autoplay;="" encrypted-media;="" gyroscope;="" picture-in-picture="" allowfullscreen=""></iframe>`;
        }
        const imageSrcIndex = token.attrIndex('src');
        const imageSrc = token.attrs[imageSrcIndex][1];
        const altIndex = token.attrIndex('alt');
        const alt = token.attrs[altIndex][1];
        return `<figure class='image'><img src=${imageSrc} alt=${alt}/></figure>`;
    };
};
exports.default = youtubeEmbedder;
//# sourceMappingURL=youtube-embedder.js.map